import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30bc183e")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_resize_observer = _resolveComponent("q-resize-observer")
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")
  const _component_q_dialog = _resolveComponent("q-dialog")
  const _directive_close_popup = _resolveDirective("close-popup")

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _ctx.modelValue,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.modelValue = $event)),
    ref: "dialog",
    class: "fullscreen-image",
    onHide: _ctx.hideHandler
  }, {
    default: _withId(() => [
      _createVNode("div", {
        class: "wrap",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickOutside(...args)))
      }, [
        _withDirectives(_createVNode(_component_q_btn, {
          icon: "close",
          flat: "",
          round: "",
          class: "close-btn"
        }, null, 512), [
          [_directive_close_popup]
        ]),
        _createVNode("div", { style: _ctx.style }, [
          _createVNode("img", {
            id: "img",
            src: _ctx.src,
            class: [
						'fullscreen-image__img',
						{ 'fullscreen-image__img--loaded': !_ctx.loading }
					],
            style: _ctx.style,
            onLoad: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loading = false)),
            onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.errorHandler(...args))),
            onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
          }, null, 46, ["src"]),
          _createVNode(_component_q_resize_observer, { onResize: _ctx.onResize }, null, 8, ["onResize"])
        ], 4),
        _createVNode(_component_q_inner_loading, {
          showing: _ctx.loading,
          color: "primary",
          class: "fullscreen-image__loading"
        }, null, 8, ["showing"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onHide"]))
})